import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-66ee94f6")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "line" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, " © 2021 Airbnb, Inc ")
  ])
], -1)
_popScopeId()


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cols = [
  {
    title: "О НАС",
    links: [
      "Как устроена платформа Airbnb",
      "Пресс-центр",
      "Airbnb 2021",
      "Для инвесторов",
      "Airbnb Plus",
      "Airbnb Luxe",
      "HotelTonight",
      "Airbnb для бизнеса",
      "С хозяевами возможно всё",
      "Карьера в Airbnb",
      "Письмо от основателей Airbnb",
    ],
  },
  {
    title: "СООБЩЕСТВО",
    links: [
      "Личностное многообразие и принятие",
      "Доступность",
      "Принимайте афганских беженцев",
      "Гости-рефералы",
      "Airbnb.org",
    ],
  },
  {
    title: "ПРИНИМАЙТЕ ГОСТЕЙ",
    links: [
      "Сдайте жилье",
      "Организуйте онлайн-Впечатление",
      "Организуйте Впечатление",
      "Ответственный прием гостей",
      "Центр ресурсов",
      "Центр общения",
    ],
  },
  {
    title: "ПОДДЕРЖКА",
    links: [
      "Действия Airbnb во время пандемии",
      "Центр помощи",
      "Отмена в период пандемии",
      "Поддержка соседей",
      "Доверие и безопасность",
    ],
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cols, (col) => {
        return _createElementVNode("div", {
          class: "col",
          key: col.title
        }, [
          _createElementVNode("header", {
            textContent: _toDisplayString(col.title)
          }, null, 8, _hoisted_2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.links, (link) => {
            return (_openBlock(), _createElementBlock("a", {
              key: link,
              textContent: _toDisplayString(link),
              href: "#"
            }, null, 8, _hoisted_3))
          }), 128))
        ])
      }), 64))
    ]),
    _hoisted_4,
    _hoisted_5
  ]))
}
}

})